/* TGFM cart v3: solo compatibilita' di rimozione per bundle legacy. */
(function () {
  'use strict';

  var removalInProgress = false;

  function cartForm() {
    return document.querySelector('form[data-tgfm-cart-v3-update-url]');
  }

  function showError(message) {
    var form = cartForm();
    var list = form && form.querySelector('[data-cart-item-list]');
    if (!form || !list) return;

    var error = form.querySelector('[data-tgfm-cart-v3-error]');
    if (!error) {
      error = document.createElement('p');
      error.className = 'tgfm-cart-v3__error';
      error.setAttribute('data-tgfm-cart-v3-error', '');
      error.setAttribute('role', 'alert');
      error.setAttribute('tabindex', '-1');
      list.parentNode.insertBefore(error, list);
    }
    error.textContent = message;
    error.focus();
  }

  function restoreLink(link, label) {
    removalInProgress = false;
    link.removeAttribute('aria-busy');
    link.setAttribute('aria-label', label);
  }

  function removeLegacyBundle(event) {
    var target = event.target && event.target.closest
      ? event.target.closest('[data-cartitem-remove]')
      : null;
    if (!target) return;

    var line = target.closest('[data-cartitem]');
    if (!line) return;
    var legacyKeysValue = line.getAttribute('data-tgfm-v3-legacy-child-keys') || '';
    if (!legacyKeysValue) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (removalInProgress) return;

    var form = cartForm();
    var updateUrl = form ? form.getAttribute('data-tgfm-cart-v3-update-url') : '';
    var parentKey = line.getAttribute('data-cartitem-key') || '';
    if (!updateUrl || !parentKey) {
      showError('Non è stato possibile identificare il bundle storico da rimuovere.');
      return;
    }

    var updates = {};
    updates[parentKey] = 0;
    legacyKeysValue.split(',').forEach(function (key) {
      var safeKey = key.trim();
      if (safeKey) updates[safeKey] = 0;
    });

    removalInProgress = true;
    var idleLabel = target.getAttribute('aria-label') || 'Rimuovi prodotto';
    target.setAttribute('aria-busy', 'true');
    target.setAttribute('aria-label', 'Rimozione in corso');

    fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw { status: response.status };
      return response.json();
    }).then(function () {
      window.location.reload();
    }).catch(function () {
      restoreLink(target, idleLabel);
      showError('Non è stato possibile rimuovere il bundle storico. Riprova.');
    });
  }

  document.addEventListener('click', removeLegacyBundle, true);
})();
